import Model from './Model';

export default class Address extends Model {
    resource () {
        return 'addresses';
    }
}
